class HeaderElement extends HTMLElement {
  connectedCallback() {
    this.initVariables();
    this.setHeight();
    this.addEventListeners();
  }

  initVariables() {
    this.megaMenuItems = this.querySelectorAll('mega-menu-item');
    this.tabletMediaQuery = globalThis.matchMedia('(max-width: 1024px)');
    this.isTablet =
      /ipad/i.test(navigator.userAgent) || this.tabletMediaQuery.matches;
    this.headerElement = document.querySelector('[data-menu]');
    this.megaMenuItemsGroup = document.querySelectorAll(
      '[data-mega-menu-item]'
    );
    this.cursorX = 0;
    this.cursorY = 0;
  }

  addEventListeners() {
    // Add event listener for each mega menu item to close the mega menu when the cursor leaves the mega menu item
    for (const megaMenuItem of this.megaMenuItems) {
      megaMenuItem.addEventListener('mouseleave', event => {
        if (this.cursorX !== event.clientX || this.cursorY !== event.clientY) {
          this.cursorX = event.clientX;
          this.cursorY = event.clientY;

          const cursorElement = document.elementFromPoint(
            event.clientX,
            event.clientY
          );

          if (!cursorElement) return;

          // Do not run for ipads because the cursor is not the same as the mouse and will prevent the mega menu links from being clickable
          if (!navigator.maxTouchPoints > 1) {
            this.closeMegaMenu(cursorElement);
          }
        }
      });
    }
  }

  /**
   * Set the height of the header in the CSS custom property.
   */
  setHeight() {
    document.documentElement.style.setProperty(
      '--header-height',
      this.parentElement.offsetHeight + 'px'
    );
  }

  /**
   * Close the mega menu if the cursor leaves the mega menu item or header element
   * @param {object} htmlElement - The HTML element that the cursor is currently over
   * @return {void}
   */
  closeMegaMenu(htmlElement) {
    if (!htmlElement || this.isTablet) return;

    if (!Object.hasOwn(htmlElement.dataset, 'megaMenuContainer')) {
      {
        // Close mega menus
        const activeMegaMenus = document.querySelectorAll(
          '[data-mega-menu].active'
        );
        for (const activeMegaMenu of activeMegaMenus) {
          activeMegaMenu.classList.remove('active');
        }

        // Reset all menu items to inactive state
        for (const megaMenuItem of this.megaMenuItems) {
          megaMenuItem.classList.remove('active');
        }
        // Reset header state
        this.headerElement.classList.remove('parent-active');
      }
    }
  }
}

customElements.get('header-element', HeaderElement) ||
  customElements.define('header-element', HeaderElement);
